// extracted by mini-css-extract-plugin
export var explainable = "_g6-a";
export var printerCard = "_g6-1";
export var printerCardConfigured = "_g6-2";
export var printerCardError = "_g6-3";
export var printerCardsContainer = "_g6-0";
export var printerIcon = "_g6-8";
export var printerIconConfigured = "_g6-5";
export var printerIconContainer = "_g6-4";
export var printerIconError = "_g6-6";
export var printerIconUnconfigured = "_g6-7";
export var workstationsTableCard = "_g6-9";